import cx from 'classnames';
import React, { ReactNode } from 'react';

import './spec-course-lesson-view__content-wrapper.scss';

interface Props {
    children: ReactNode | ReactNode[];
    mix?: string;
}

export const SpecCourseLessonViewContentWrapper = ({ children, mix }: Props) => {
    return <div className={cx('spec-course-lesson-view__content-wrapper', mix)}>{children}</div>;
};
